<!-- MNDNR Logo -->
<img src="assets/images/main_banner_logo.jpg" width="100%" alt="Minnesota DNR logo on top of photo of lake and dock" />

<!-- Application Title -->
 <h2 mat-dialog-title style="font-weight:bold; color:#003865">Lake & Flood Elevations Online &#40;LFEO&#41;</h2>

<!-- About dialog -->
<mat-dialog-content class="mat-typography" style="color:#003865">

    <p>Not all lakes and basins have flood elevations listed. Information is only shown if it is based on current effective FEMA flood studies or other sources determined by Minnesota DNR &#40;MNDNR&#41; to be best available data that meets minimum quality standards.</p>

    <p>If no flood elevation information is shown in this viewer, it is possible that MNDNR has study information that can be used, depending on the situation. Check with <a href="https://files.dnr.state.mn.us/waters/area_hydros.pdf" target="_blank">DNR Area Hydrologists<span class="sr-only">, opens in a new window</span></a> or <a href="mailto:floodplain.dnr@state.mn.us">DNR Floodplain Program staff</a>.</p>

    <p>For detailed information on navigation and the data in this application, see <a href="https://files.dnr.state.mn.us/eco/lakemapping/lfeo-faq.pdf" target="_blank">Frequently Asked Questions<span class="sr-only">, opens in a new window</span></a>.</p>

</mat-dialog-content>

<!-- Close button -->
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>
